export default __webpack_public_path__ + "static/media/5024.6305a832.png";